import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import TherapistSidebar from "../../components/TherapistSidebar";


const TherapistAdminPanel = () => {
  const location = useLocation();
    const [activeNavItem, setActiveNavItem] = useState("clients");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  return (
        <div className="max-w-3xl w-full bg-white shadow-lg rounded-2xl p-4 sm:p-8">
          <TherapistSidebar
        activeNavItem={activeNavItem}
        setActiveNavItem={setActiveNavItem}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <p className="text-sm font-semibold uppercase tracking-wide text-blue-600 mb-2">Therapist tools</p>
      <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-2">
        Scheduling Dashboard
      </h1>
      <p className="text-sm sm:text-base text-gray-500 mb-6">Choose what you need to do for this client.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        <Link
          to="/clients/schedule/session"
          state={location.state} 
          className="group min-h-[112px] p-4 bg-blue-50 border border-blue-200 text-blue-950 rounded-2xl shadow-sm hover:bg-blue-100 transition flex flex-col justify-between"
        >
          <span className="text-lg font-bold">Schedule session</span>
          <span className="text-sm text-blue-700">Schedule this client's session</span>
        </Link>
        <Link
          to="/clients/schedule/link-generator"
          state={location.state} 
          className="group min-h-[112px] p-4 bg-orange-50 border border-orange-200 text-orange-950 rounded-2xl shadow-sm hover:bg-orange-100 transition flex flex-col justify-between"
        >
          <span className="text-lg font-bold">Instant link</span>
          <span className="text-sm text-orange-700">Generate a quick session link</span>
        </Link>
      </div>
    </div>
  );
};

export default TherapistAdminPanel;
